import QuillBlock, { BlockEmbed } from 'quill/blots/block';
import type { Blot } from './types';

const closestLine = (blot: Blot | null | undefined): Blot | null => {
  let current = blot;
  while (current) {
    if (current instanceof QuillBlock || current instanceof BlockEmbed) {
      return current;
    }
    current = current.parent;
  }
  return null;
};

export default closestLine;
